import lottie from 'lottie-web-light';

class Lottie {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-lottie'
        };

        this.settings = Object.assign({}, defaults, options);

        this.$lottie = element;
        this.lottie = null;

        this.$toggleButton = this.$lottie.parentNode.querySelector('.fullscreen-section__play-toggle-button');

        this.initialize();
    }

    initialize () {
        const lottiePath = this.$lottie.getAttribute('data-lottie');
        let loopAnimation = false;
        const dataLoop = this.$lottie.getAttribute('data-animation');

        if (dataLoop) {
            loopAnimation = true;
        }

        if (lottiePath) {
            const lottieAnimation = lottie.loadAnimation({
                container: this.$lottie, // the dom element that will contain the animation
                renderer: 'svg',
                loop: loopAnimation,
                autoplay: false,
                path: lottiePath
            });

            // this.$lottie.API = lottie;
            this.lottie = lottie;
            if (this.$toggleButton) {
                lottieAnimation.addEventListener('complete', () => {
                    this.$toggleButton.classList.add('has--stopped');
                    this.$toggleButton.classList.add('is--finished');
                });
            }
        }

        this.setEvents();
    }

    setEvents () {
        if (this.$toggleButton) {
            this.$toggleButton.addEventListener('click', () => {
                if (this.$toggleButton.classList.contains('has--stopped')) {
                    this.$toggleButton.classList.remove('has--stopped');
                    if (this.$toggleButton.classList.contains('is--finished')) {
                        this.lottie.stop();
                        this.$toggleButton.classList.remove('is--finished');
                    }
                    this.lottie.play();
                } else {
                    this.$toggleButton.classList.add('has--stopped');
                    this.lottie.pause();
                }
            });
        }
    }
}

export { Lottie };
